import Bluebird from 'bluebird';
import { apiCall } from './api';

const ratesCache: { [base: string]: { [currency: string]: number } } = {};

export default async function getExchangeRates(base: string = 'EUR'): Bluebird<{ [currency: string]: number }> {
    const cached = ratesCache[base];
    if (cached) return cached;

    const result: { [currency: string]: number } = {};
    result[base] = 1;

    try {
        const rates = (await apiCall<API.CurrenciesResponse>('GET', `currencies/${base}/rates`, null, {
            groupURL: 'currencies/{base}/rates'
        })).data;

        if (rates.length === 0) {
            throw new Error('Currencies response contained no data');
        }

        rates.forEach(currency => {
            result[currency.iso] = currency.rate;
        });
    } catch (e) {
        throw new Error(`Could not retrieve exchange rates with base ${base}`);
    }

    return ratesCache[base] = result;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/exchange-rates.ts